import { Component, OnInit, ViewChild } from '@angular/core';
import { MatAccordion } from '@angular/material';
import { Seguimiento_exp_Service } from 'src/app/services/seguimiento_exp.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, Validators } from '@angular/forms';
import { RutValidator } from 'ng2-rut';
import { GLOBAL } from 'src/app/services/global';
import { trigger, transition, style, animate } from '@angular/animations';
import { DataTransferService } from 'src/app/services/dataTransfer.service';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { formatNumber } from '@angular/common';

declare const swal: any;
@Component({
  selector: 'app-seguimiento-exp',
  templateUrl: './seguimiento-exp.component.html',
  styleUrls: ['./seguimiento-exp.component.css'],
  providers: [Seguimiento_exp_Service, DataTransferService, UserService],
  animations: [
    trigger('enterAnimation', [
      transition(':enter', [
        style({ transform: 'translateX(0)', opacity: 0 }),
        animate('400ms', style({ transform: 'translateX(0)', opacity: 1 }))
      ])
    ])
  ]
})
export class SeguimientoExpComponent implements OnInit {
  @ViewChild(MatAccordion) accordion: MatAccordion;
  displayedColumns: string[] = ['nombre', 'option'];
  dataSource = "";
  displayedColumns2: string[] = ['nombre', 'option'];
  dataSource2 = "";

  public expediente
  public reiteros
  public cantReiteros = false
  public ingreso; //form
  public numero; //form
  public propietario; //form
  public sendData = { rut: "", depto: "", num: "" }
  public ingrese = false
  public pasonum = false
  public pasoTabla = false
  public nsol = false
  public conFecha = true
  public conFechaNotiActa = false
  public conFechaNotiReiteroActa = false
  public btnActa = true
  public footer = GLOBAL.footer;
  public web = GLOBAL.web;
  public webUrl = GLOBAL.webUrl;

  //bandera calculo
  public calculo //buscar datos para monto
  public mostrarPago = true //calculo derecho bandera
  public montoPago //calculo derecho 
  public montoPagoFormat //calculo derecho 
  public calculo_encontrado
  public fecha_calculo_finalizado


  constructor(
    private userService: UserService,
    private _seguimientoService: Seguimiento_exp_Service,
    private _dataService: DataTransferService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    rutValidator: RutValidator,
    private _router: Router
  ) {
    /*     this.accordion.openAll() */
    this.ingreso = this.fb.group({
      rut: ['', [Validators.required, rutValidator, Validators.minLength(8)]],
      depto: ['', [Validators.required]],
    })
    this.numero = this.fb.group({
      num: ['', [Validators.required]],
    })
    this.propietario = this.fb.group({
      rutProp: ['', [Validators.required, rutValidator, Validators.minLength(8)]],
      monto: [0],
    })
  }

  ngOnInit() {

    this.expediente = {}
    /* this.spinner.show();  no sirve un spinner acá por */

  }

  buscarRut() {
    this.pasonum = true
    if (this.ingreso.value.depto == "EDIFICACIÓN") {
      this.nsol = false
    }
    if (this.ingreso.value.depto == "URBANIZACION" || this.ingreso.value.depto == "RECEPCIONES") {
      this.nsol = true
    }

    this.sendData.rut = this.ingreso.value.rut
    this.sendData.depto = this.ingreso.value.depto

  }

  buscarNum() {
    this.ingrese = true
    this.sendData.num = this.numero.value.num


    this.askForCalculo()
    /* this.getExpediente() */
  }

  salir() {
    /*  this.form.controls['fecha'].setValue */
    this.expediente = {}
    this.ingreso.controls["rut"].setValue("")
    this.ingreso.controls["depto"].setValue("")
    this.numero.controls["num"].setValue("")
    this.ingreso.value.rut = ""
    this.ingreso.value.depto = ""
    this.numero.value.num = ""

    this.nsol = false
    this.pasonum = false
    this.ingrese = false
    this.pasoTabla = false
    this.conFechaNotiActa = false
    this.conFechaNotiReiteroActa = false
    this.conFecha = true
  }

  getExpediente() {
    window.scrollTo(0, 0);
    this.spinner.show();
    this._seguimientoService.getExpediente(this.sendData).subscribe(//traer desde session o localStorage
      expediente => {

        let alert = { icon: 'success', text: '', title: '' }
        if (expediente.success) {
          var data = expediente.data
          console.log('getExpediente Response', data)

          this.expediente = {
            dire: data['Tramite_Solicitudes::TRA_Pro_Direccion'],
            expe: data['_Tex_ID_materia_Solicitud_Proexsi_ano'],
            sol: data['_Tex_ID_Solicitud'],
            tipo: data['Tramites 5::TRAEXP_Tipo'],
            rol: data['Tramite_Solicitudes::TRA_Pro_Rol_Imprimir'],
            fecha: data['TRAIN_Fecha_Creacion'],
            nombre_arq: data['Administracion 5::Adm_Nombre_Completo'],
            email_arq: data['Administracion 5::Adm_Mail'],
            f_noti_acta: data['TCo_Acta_depto'],
            f_ingre_acta: data['TCo_Acta_Fec_Ingr'],
            n_permiso: data['Tramite_Expedientes_Permisos::TExP_Permiso_Numero_Final'],
            f_permiso: data['Tramite_Expedientes_Permisos::TExP_Permiso_Fecha_Final'],
            acta_firma: data['_TRA_Firma'],
            estado: data['Tramite_Solicitudes::TRA_Estado_Descripcion'],
            depto: this.capitalize((data['Tramites 5::TRAEXP_DptoCompleto']).toLowerCase()),
          }

          if (this.expediente.f_noti_acta == "") {
            console.log("Sin Fecha notificacion acta ", this.expediente.f_noti_acta)
            this.conFechaNotiActa = true
          }
          if (this.expediente.f_permiso == "") {
            console.log("Sin Fecha permiso ", this.expediente.f_permiso)
            this.conFecha = false
          }


          this.getDocs()



        } else {
          this.salir()
          console.log('error al traer expediente', expediente.msg)
          this.spinner.hide();

          alert.icon = 'error'
          alert.text = '<p><strong>' + expediente.msg + '<strong></p>'
          alert.title = 'No se pudo ejecutar la acción'
          swal({
            icon: alert.icon,
            title: alert.title,
            text: alert.text,
            showConfirmButton: true,
            confirmButtonText: 'Aceptar',
            allowOutsideClick: false
          }).then(
            () => {
              window.scrollTo(0, document.body.scrollHeight);
            }
          );
        }
      },
      error => {
        this.salir()
        console.log('error al traer expediente', error)
        this.spinner.hide();

      }
    )
  }

  capitalize(word) {
    return word[0].toUpperCase() + word.slice(1);
  }

  getActa(acta) {
    console.log("getActa parametros", acta)


    if (acta) {
      window.scrollTo(0, 0);
      this.spinner.show();
      this._seguimientoService.downloadAttachment(acta).subscribe(//traer desde session o localStorage
        respActa => {
          let alert = { icon: 'success', text: '', title: '' }
          if (respActa.success) {
            console.log("downloadAttachment Response", respActa.data.response)
            var acta = respActa.data.response.data[0]
            this.downloadFile(acta.fieldData.Documento, 'Acta de Observaciones_' + this.sendData.num);
            this.spinner.hide();


          } else {
            console.log('error al traer acta', respActa.msg)
            this.spinner.hide();

            alert.icon = 'error'
            alert.text = '<p><strong>' + respActa.msg + '<strong></p>'
            alert.title = 'No se pudo ejecutar la acción'
            swal({
              icon: alert.icon,
              title: alert.title,
              text: alert.text,
              showConfirmButton: true,
              confirmButtonText: 'Aceptar',
              allowOutsideClick: false
            }).then(
              () => {
                window.scrollTo(0, document.body.scrollHeight);
              }
            );
          }
        },
        error => {
          console.log('error al traer acta', error)
          this.spinner.hide();
        })

    } else {
      let alert = { icon: 'success', text: '', title: '' }

      console.log("No posee firma")
      alert.icon = 'error'
      alert.text = '<p><strong>No posee firma<strong></p>'
      alert.title = 'No se pudo ejecutar la acción'
      swal({
        icon: alert.icon,
        title: alert.title,
        text: alert.text,
        showConfirmButton: true,
        confirmButtonText: 'Aceptar',
        allowOutsideClick: false
      }).then(
        () => {
          window.scrollTo(0, document.body.scrollHeight);
        }
      );
    }
  }

  downloadFile(data, filename = 'data') {
    let blob = this.convertBase64ToBlobData(data);

    /* let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' }); */
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".pdf");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  convertBase64ToBlobData(base64Data: string, contentType: string = 'image/png', sliceSize = 512) {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  getDocsReitero() {

    this._seguimientoService.getDocumentsReitero(this.expediente.sol).subscribe(
      respDocs => {
        let alert = { icon: 'success', text: '', title: '' }
        if (respDocs.success) {
          console.log("getDocuments Response", respDocs.data)
          this.dataSource2 = respDocs.data.data
          /*  this.downloadFile(respDocs.data.Documento, 'Acta de Observaciones_' + this.sendData.num); */
          this.btnActa = false
          /*  this.spinner.hide(); */

          if (this.dataSource == "") {
            this.pasoTabla = false
          } else {
            this.pasoTabla = true
          }


          /*  this.getReitero_pdf("683") */
        } else {
          console.log('error al traer documentos', respDocs.msg)
          this.btnActa = false
          /*  this.spinner.hide(); */
        }

      },
      error => {
        console.log('error al traer documentos', error)
        this.spinner.hide();
      })


  }

  getDocReitero(element, id, nombre) {
    window.scrollTo(0, 0);
    this.spinner.show();
    console.log("getDocReitero row", element)
    this._seguimientoService.downloadDocumentsReitero(id, "SOL_" + this.expediente.sol + nombre, nombre)

    setTimeout(() => {
      this.spinner.hide();
    }, 4000);
  }


  getDocs() {

    this._seguimientoService.getDocuments(this.expediente.sol).subscribe(
      respDocs => {
        let alert = { icon: 'success', text: '', title: '' }
        if (respDocs.success) {
          console.log("getDocuments Response", respDocs.data)
          this.dataSource = respDocs.data.data
          /*  this.downloadFile(respDocs.data.Documento, 'Acta de Observaciones_' + this.sendData.num); */
          this.btnActa = false
          /*  this.spinner.hide(); */

          if (this.dataSource == "") {
            this.pasoTabla = false
          } else {
            this.pasoTabla = true
          }


          /*  this.getReitero_pdf("683") */
        } else {
          console.log('error al traer documentos', respDocs.msg)
          this.btnActa = false
          /*  this.spinner.hide(); */
        }

        this.getListReiteros_pdf()
      },
      error => {
        console.log('error al traer documentos', error)
        this.spinner.hide();
      })


  }

  getDoc(element, id, nombre) {
    window.scrollTo(0, 0);
    this.spinner.show();
    console.log("getDoc row", element)
    this._seguimientoService.downloadDocuments(id, "SOL_" + this.expediente.sol + nombre, nombre)

    setTimeout(() => {
      this.spinner.hide();
    }, 4000);
  }


  toPay() {
    console.log("Direccionando a pago ", this.propietario.value)

    var data = { rut: this.ingreso.value.rut, prop: this.propietario.value, num: this.numero.value.num, depto: this.ingreso.value.depto }
    localStorage.setItem("dataTransferP", JSON.stringify(data))
    this._dataService.newData(data)

    window.open(`/#/pago_calculo_derecho`, '_blank');
    /* this._router.navigate([`/pago_calculo_derecho`]); */
  }

  toObs() {
    console.log("Direccionando a obs acta ", this.ingreso.value, this.numero.value)

    var data = { rut: this.ingreso.value.rut, num: this.numero.value.num, depto: this.ingreso.value.depto }
    localStorage.setItem("dataTransferO", JSON.stringify(data))
    this._dataService.newData(data)

    window.open(`/#/ingreso_observaciones`, '_blank');
    /* this._router.navigate([`/ingreso_observaciones`]); */

  }

  askForCalculo() {
    window.scrollTo(0, 0);
    this.spinner.show()
    var valueSol = ""
    var valueExp = ""
    if (this.ingreso.value.depto == "EDIFICACIÓN") {
      valueExp = this.numero.value.num //expediente
    }
    if (this.ingreso.value.depto == "URBANIZACION" || this.ingreso.value.depto == "RECEPCIONES") {
      valueSol = this.numero.value.num  //Solicitud
    }
    this.userService.get_calculo_derecho(this.ingreso.value.rut, valueExp, valueSol).subscribe(resp => {
      console.log("get_calculo_derecho Respuesta server", resp)
      this.getExpediente()
      if (resp.status == "error") {
        /*  console.log("get_calculo_derecho", resp) */
      } else {
        this.calculo_encontrado = true
        this.calculo = resp.derecho
        if (this.calculo.data[0].fieldData.TCo_Acta_Fec_FInalizada == "") {
          this.fecha_calculo_finalizado = false
        }

        /*  this.mostrarPago
         console.log(this.calculo) */

        if (this.calculo.data[0].fieldData.Tco_Acta_6_Cal_Notifica_Pago != "") {

          this.propietario.controls.monto.setValue(formatNumber(Math.round(this.calculo.data[0].fieldData.TRA_CD_TOTAL_PAGAR), 'cl'))

          this.montoPagoFormat = formatNumber(Math.round(this.calculo.data[0].fieldData.TRA_CD_TOTAL_PAGAR), 'cl')
          this.montoPago = this.calculo.data[0].fieldData.TRA_CD_TOTAL_PAGAR
        } else {
          this.mostrarPago = false
        }
      }

    }, error => {
      console.log(error)
    })
  }

  getListReiteros_pdf() {
    this._seguimientoService.getReiteros_list(this.expediente.sol).subscribe(
      resp => {
        this.getDocsReitero()
        console.log("getReiteros_list Response", resp)
        this.reiteros = resp.data
        this.cantReiteros = this.reiteros.length == 0 ? false : true;
        this.spinner.hide();

        for (let inRei = 0; inRei < this.reiteros.length; inRei++) {
          const reitero = this.reiteros[inRei];
          /* reitero.fieldData.TEAc_Fec_Notificacion = "" */ //test reitero sin fecha de notificación
          if (reitero.fieldData.TEAc_Fec_Notificacion == "") {
            console.log("Sin Fecha notificacion reitero acta ", reitero.fieldData.TEAc_Fec_Notificacion)
            reitero.fecha = false
          } else {
            reitero.fecha = true
          }
        }


        console.log("this.reiteros ", this.reiteros)
      }, error => {
        console.log(error)
      })
  }

  getReitero_pdf(acta) {
    window.scrollTo(0, 0);
    this.spinner.show();
    console.log("getReitero_pdf parametros ", acta)

    if (acta) {

      this._seguimientoService.downloadReitero_pdf(acta, "SOL_Reitero_Acta" + this.expediente.sol + ".pdf")

      this.spinner.hide();
    } else {
      let alert = { icon: 'success', text: '', title: '' }
      this.spinner.hide();
      console.log("No posee reitero")
      alert.icon = 'error'
      alert.text = '<p><strong>No posee reitero de acta<strong></p>'
      alert.title = 'No se pudo ejecutar la acción'
      swal({
        icon: alert.icon,
        title: alert.title,
        text: alert.text,
        showConfirmButton: true,
        confirmButtonText: 'Aceptar',
        allowOutsideClick: false
      }).then(
        () => {
          window.scrollTo(0, document.body.scrollHeight);
        }
      );
    }
  }

  getObsReitero(acta) {
    console.log("getObsReitero parametros ", acta.fieldData)
    if (acta) {
      /*     this._seguimientoService.downloadReitero_pdf(acta, "SOL_Reitero_Acta" + this.expediente.sol + ".pdf") */

      console.log("Direccionando a observaciones reitero", this.ingreso.value, this.numero.value)

      var data = {
        rut: this.ingreso.value.rut,
        num: this.numero.value.num,
        depto: this.ingreso.value.depto,
        actReiteros: acta.fieldData._TEAc_Id,
        id_soL: acta.fieldData._TEAc_Sol,
        tipo: this.expediente.tipo,
        fechaCreacion: this.expediente.fecha,
        fechaNotifi: acta.fieldData.TEAc_Fec_Notificacion,
      }
      localStorage.setItem("dataTransferO", JSON.stringify(data))
      this._dataService.newData(data)

      window.open(`/#/ingreso_observaciones`, '_blank');
      /* this._router.navigate([`/ingreso_observaciones`]); */
    }
  }
}
